import React from 'react'
import './Contactus.css'
import { Facebook, Instagram, Whatsapp } from 'react-bootstrap-icons';
import Footer from './footer';
import Navbar from './Navbar';
import bg from '../Images/ContactBackground.jpg'

export default function ContactUs() {
  return (
    <>
    <div
                  className="bg-image w-100"
                  style={{
    backgroundColor: "none",
    backgroundRepeat: "none",
    width: "100%",
    backgroundImage: "url('https://img.freepik.com/free-vector/worldwide-connection-gray-background-illustration-vector_53876-61772.jpg?w=900&t=st=1675540746~exp=1675541346~hmac=7735cb8c295913a34aa53adedddaa81dc054da606e6335529b16ed75c968cbbd')",
    height: "100vh"
  }}
              >
                  <div className="col-md-12" style={{backgroundColor: "rgba(0, 0, 0, 0.3)",height: "100vh",color: "white"}}>
                      <div className="formAndDetails col-md-12">
                      <form className='col-md-4 mx-5 getInTouchForm'>
                        <h1 className='my-2'>Get in Touch</h1>
                              <div className="form-group">
                                  <input type="email" className="form-control allInput my-4" id="inputEmail4" placeholder="Name" />
                              </div>
                          <div className="form-group">
                              <input type="text" className="form-control allInput my-4" id="inputAddress" placeholder="Email" />
                          </div>
                          <div className="form-group">
                              <input type="text" className="form-control allInput my-4" id="inputAddress" placeholder="Phone" />
                          </div>
                          <div className="form-group">
                              <textarea className="form-control allInput" id="exampleFormControlTextarea1" rows="3" placeholder='Your Message'></textarea>
                          </div>
                          <button type="submit" className="btn btn-contact my-3"
                          style={{width: "30%"}} >Submit</button>
                      </form>
                      <div className='col-md-1'></div>
                      <div className='col-md-3 mx-6 details'>
                        <div className='text-right mx-6'>
                            <h5>Get in Touch</h5>
                            <p>ABC, Garden Town,<br></br>
                            Lahore, Punjab, <br></br>
                            Pakistan. <br></br>
                            <br></br>
                            Phone: +92**-******<br></br>
                            We are Open Monday to Friday<br></br>
                            8:00-5:00<br></br>
                            <br></br>
                            <strong>Follow Us:</strong><br></br>
                            <a href='https://www.youtube.com/watch?v=dbYWKVAeu6Y' style={{color: "white"}}>
                            <Facebook className='m-2' style={{fontSize: "1.5rem"}}></Facebook>
                            </a>
                            <a href='https://www.youtube.com/watch?v=dbYWKVAeu6Y' style={{color: "white"}}>
                            <Instagram className='mx-2' style={{fontSize: "1.5rem"}}></Instagram>
                            </a>
                            <a href='https://www.youtube.com/watch?v=dbYWKVAeu6Y' style={{color: "white"}}>
                            <Whatsapp className='mx-2' style={{fontSize: "1.5rem"}}></Whatsapp>
                            </a>
                            </p>
                        </div>
                      </div>
                      </div>
                  </div>
              </div>

    </>
  )
}
